import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../../icon';

export const SentimentSuccessIcon = (props: IconProps) => (
  <ChakraIcon
    width="16"
    height="16"
    viewBox="0 -0.2 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6668 8.00004C14.6668 11.6819 11.6821 14.6667 8.00016 14.6667C4.31826 14.6667 1.3335 11.6819 1.3335 8.00004C1.3335 4.31814 4.31826 1.33337 8.00016 1.33337C11.6821 1.33337 14.6668 4.31814 14.6668 8.00004ZM11.8138 5.48436C11.5769 5.27281 11.2057 5.28506 10.9846 5.51172L7.26166 9.32883L5.6353 7.99484C5.3893 7.79306 5.01894 7.82032 4.80808 8.05574C4.59721 8.29115 4.6257 8.64556 4.87171 8.84734L6.92504 10.5315C7.16372 10.7273 7.52123 10.7083 7.73572 10.4884L11.8424 6.27783C12.0635 6.05117 12.0507 5.69592 11.8138 5.48436Z"
      fill="#00CC18"
    />
  </ChakraIcon>
);
